var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalanceicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_30_1",
    "data-name": "Component 30 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.778,
    height: 38.165,
    viewBox: "0 0 35.778 38.165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M179.891,234.033a3.058,3.058,0,0,0,1.2,2.579A9.711,9.711,0,0,0,184.1,238.3a28.435,28.435,0,0,0,9.707,1.518c.685-.04,1.743-.075,2.8-.171A23.048,23.048,0,0,0,203,238.22a9.517,9.517,0,0,0,2.809-1.609,3.069,3.069,0,0,0,1.2-2.581c-.044-.858-.041-1.722,0-2.58a3.007,3.007,0,0,0-1.137-2.479,9.576,9.576,0,0,0-3.107-1.758,24,24,0,0,0-6.8-1.383,29.762,29.762,0,0,0-10.833,1.042,10.838,10.838,0,0,0-4.073,2.071,3.028,3.028,0,0,0-1.167,2.551A24.134,24.134,0,0,1,179.891,234.033Z",
    transform: "translate(-171.238 -225.735)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M254.823,344.756a10.63,10.63,0,0,0,4.026-2.072A3.016,3.016,0,0,0,260,340.168c-.043-.858-.008-1.72-.01-2.581,0-.118-.014-.237-.024-.379-.509.3-.968.6-1.453.845a25.186,25.186,0,0,1-10,2.4,3.178,3.178,0,0,1,.175,1.042,3.48,3.48,0,0,1-1.291,2.639l-1.978,1.759A28.637,28.637,0,0,0,254.823,344.756Z",
    transform: "translate(-224.224 -315.875)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M225.76,380.713V379.6c-.534.313-.993.613-1.478.86a25.431,25.431,0,0,1-10.2,2.41,33.706,33.706,0,0,1-5.752-.162l-.807.717-1.87,1.663-.31.277c-.313.282-.637.573-.992.866a3.683,3.683,0,0,1-1.27.675,24.275,24.275,0,0,0,6.68,1.321,29.682,29.682,0,0,0,10.871-1.079,10.56,10.56,0,0,0,3.986-2.058,2.984,2.984,0,0,0,1.146-2.516C225.729,381.956,225.76,381.333,225.76,380.713Z",
    transform: "translate(-189.996 -350.153)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M180.5,400.209c.008.028.016.056.025.084V400.2Z",
    transform: "translate(-171.736 -366.811)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M180.09,299.852a3.355,3.355,0,0,1,1.953-2.715,16.558,16.558,0,0,1-2.113-1.183c0,1.022.012,1.977,0,2.931A2.592,2.592,0,0,0,180.09,299.852Z",
    transform: "translate(-171.27 -282.516)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M233.786,301.791a3.292,3.292,0,0,0,1.682-2.276c.109-1.112.024-2.244.024-3.4a1.42,1.42,0,0,0-.171.082,17,17,0,0,1-5.861,2.4,33.559,33.559,0,0,1-11.465.6c-.962-.111-1.913-.255-2.852-.446,1.352,1.193,2.707,2.395,4.026,3.564l1.083.96.527.468.915.81a30.123,30.123,0,0,0,7.035-.722A14.137,14.137,0,0,0,233.786,301.791Z",
    transform: "translate(-199.747 -282.643)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M149.168,331.231l2.538-2.257q2.061-1.833,4.123-3.666c.352-.313.352-.378-.012-.7l-.763-.675-1.884-1.668-1.64-1.454q-2.233-1.98-4.472-3.954a.474.474,0,0,0-.288-.1.28.28,0,0,0-.088.012c-.074.025-.131.211-.132.326-.009.682,0,1.365,0,2.047,0,.061,0,.123,0,.184,0,.46,0,.922,0,1.4-.088.008-.14.014-.193.017a10.374,10.374,0,0,0-2.228.373q-.392.11-.773.249a10.922,10.922,0,0,0-1.975.959,12.915,12.915,0,0,0-5.2,6.369,22.434,22.434,0,0,0-1.489,8.491c0,.157.031.288.212.312a.363.363,0,0,0,.048,0c.174,0,.224-.146.269-.29a10.994,10.994,0,0,1,4-5.55,12.586,12.586,0,0,1,4.137-2.121q.448-.128.911-.217a10.839,10.839,0,0,1,1.086-.156c.144-.013.289-.017.434-.017.25,0,.5.012.761.012,0,.13,0,.227,0,.324q0,.461,0,.922c0,.8-.007,1.6,0,2.4,0,.131.067.349.144.37a.257.257,0,0,0,.065.008.6.6,0,0,0,.345-.133c.416-.344.813-.712,1.217-1.071Z",
    transform: "translate(-134.695 -299.338)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/balance.icon.eb9c6a5f923b91dc5a014e92745eb58f.svg";
export { ForwardRef as ReactComponent };